import { useEffect } from "react";
import { upsertCompareVisit } from "@/utils/parlorCompareVisitStorage";

type Props = {
  parlorId: string | number;
  companyName: string;
  /** 시군구 라벨 예: "부산 동래구" */
  region: string;
  imageUrl?: string;
  minPriceManwon?: number;
};

/**
 * 식장 상세 방문 기록만 남긴다.
 *
 * #329 비교 모달은 A안(모달 없음) 승리로 제거.
 * 방문 upsert 는 multi/non_multi 분리(#328 제외, ParlorMultiSplitContainer)가
 * 이 이력에 의존하므로 식장 상세에서 계속 쌓는다.
 */
export default function ParlorCompareExperimentGate({
  parlorId,
  companyName,
  region,
  imageUrl,
  minPriceManwon,
}: Props) {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const id = String(parlorId);
    upsertCompareVisit({
      id,
      name: companyName || `식장 ${id}`,
      region: region || "",
      imageUrl,
      minPriceManwon,
    });
  }, [parlorId, companyName, region, imageUrl, minPriceManwon]);

  return null;
}
